<template>
  <div class="global-chat-active-chat-messages-container__message">
    <GlobalChatAvatarBubble v-bind:class="{'global-chat-active-chat-messages-container__avatar-currrent': rightSideAvatar}">
    </GlobalChatAvatarBubble>
    <div class="global-chat-active-chat-messages-container__bubble placeholder-card">
      <div class="global-chat-active-chat-messages-container__header">
        <div class='load-wrapper load-wrapper-header'>
          <span class='activity'></span>
        </div>
      </div>
      <div class="global-chat-active-chat-messages-container__content-text placeholder">
        <div class='load-wrapper load-wrapper-content'>
          <span class='activity'></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import GlobalChatAvatarBubble from './GlobalChatAvatarBubble.vue'

export default {

  components: {
    GlobalChatAvatarBubble
  },
  
  props: ['rightSideAvatar']

}
</script>

<style scoped>

.placeholder-card {
  height: 52px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.load-wrapper {
    position: relative;
    height: 0.8rem;
    width: 100%;
    background-color: rgb(211,211,211);
    z-index: 44;
    overflow: hidden;
    border-radius: 5px;
}

.load-wrapper-header {
  width: 40%;
}

.load-wrapper-content {
  height: 1.5rem;
}

.activity {
    position: absolute;
    left: -45%;
    height: 100%;
    width: 45%;
    background-image: linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05));
    background-image: -moz-linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05));
    background-image: -webkit-linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05));
    animation: loading 1s infinite;
    z-index: 45;
}

@keyframes loading {
    0%{
        left: -45%;
    }
    100%{
        left: 100%;
    }
}

</style>